import React, { useRef } from 'react';
import { Trip } from '@/types';
import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import TripDashboardSection from '../TripDashboardSection';
import ApartmentList from '@/components/apartment/ApartmentList';
import AddApartmentForm from '@/components/apartment/AddApartmentForm';
import { useI18n } from '@/hooks/useI18n';

interface TripApartmentsPageProps {
  trip: Trip;
}

const TripApartmentsPage: React.FC<TripApartmentsPageProps> = ({ trip }) => {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const { t } = useI18n();

  return (
    <>
      <TripDashboardSection
        icon="🏠"
        title={t('trip.dashboard.tabs.apartments')}
        subtitle={t('trip.pages.apartments.subtitle')}
        description={t('trip.pages.apartments.description')}
        primaryAction={{
          icon: <Add />,
          onClick: () => {
            triggerRef.current?.click();
          },
          label: t('trip.pages.apartments.addApartment')
        }}
      >
        <ApartmentList trip={trip} />
      </TripDashboardSection>

      <AddApartmentForm 
        tripId={trip.id}
        apartmentTypes={trip.apartmentTypes}
        trigger={
          <Button 
            ref={triggerRef}
            style={{ display: 'none' }}
          >
            {t('trip.pages.apartments.hidden')}
          </Button>
        }
      />
    </>
  );
};

export default TripApartmentsPage;
